import { render, staticRenderFns } from "./CalendarColorIcon.vue?vue&type=template&id=5c68a804&"
import script from "./CalendarColorIcon.vue?vue&type=script&lang=js&"
export * from "./CalendarColorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports